module.exports = __webpack_public_path__ + "img/symbol_roulette_anime.4195d9fc.gif";